module.exports = __webpack_public_path__ + "img/60-plus-cym-AZUL.66671ffd.svg";